<template>
  <g :transform="'translate(' + x + ',' + y + ')'" style="{dragged: dragged}" >
    <slot></slot>
  </g>
</template>

<style scoped>
g {
    cursor: grab;                
}
g.dragged {
    cursor: grabbing;
}
</style>

<script>
import * as d3 from 'd3'

export default {
  data () {
    return {
      x: 0,
      y: 0,
      dragged: false
    }
  },
  mounted () {
    d3.select(this.$el).call(
      d3.drag().on('start', () => {
        this.dragged = true
      }).on('drag', () => {
        this.x += d3.event.dx
        this.y += d3.event.dy
      }).on('end', () => {
        this.dragged = false
      })
    )    
  },
  methods: {
    getCoordinates () {
      return {
        x: this.x,
        y: this.y
      }
    },
    setCoordinates (coords) {
      this.x = coords.x
      this.y = coords.y
    }
  }
}
</script>



// WEBPACK FOOTER //
// node_modules/d3vue/components/Draggable.vue